import React, { useState } from 'react';
import styles from './productTable.module.css';
import { Downarrow, Leaf, Pdf, Uparrow } from '../../../../Svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleProductSelection } from '../../../redux/compareSlice';
import { handleQuantityChange } from '../../../utils/AddToCartorSchedule';
import { addToCartThunk } from '../../../redux/cartSlice';
import { addToScheduleThunk } from '../../../redux/ScheduleSlice';
import { stripHtmlTags } from '../../../utils/utils';


const ProductTable = ({ products,   addIds, setSearchVisible, setsearch, setProducts }) => {
    const dispatch = useDispatch()
    const { selectedData } = useSelector(state => state.compare)
    const [quantities, setQuantities] = useState({});
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({})
    const [expandedProducts, setExpandedProducts] = useState({});
    

    const navigate = useNavigate()

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };

    const handleCheckboxChange = (product) => {
        dispatch(toggleProductSelection(product));
    };

     const addtoCart = async (from, productId) => {
            const products = Object.entries(quantities).map(([id, quantity]) => ({
                productId: id,
                quantity: parseInt(quantity, 10),
                totalQty: parseInt(quantity, 10)
            }));
            if (from == 'cart') {
                setLoadingCart((prev) => ({ ...prev, [productId]: true }));
                await dispatch(addToCartThunk(products))
                setLoadingCart((prev) => ({ ...prev, [productId]: false }));
            }
            else {
                setScheduleloading((prev) => ({ ...prev, [productId]: true }));
                await dispatch(addToScheduleThunk(products))
                setScheduleloading((prev) => ({ ...prev, [productId]: false }));
            }
        }
    



    const allAttributeKeys = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.attributes || {})))
    );

    const allEnvironmentalKeys = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.environmental || {})))
    );

    const allAdditionalResources = Array.from(
        new Set(products?.flatMap(product => Object.keys(product?.additionalResources || {})))
    );


    const handleCompare = () => {
        const ids = selectedData?.map(item => item._id);
        addIds(ids)
        setsearch('')
        setSearchVisible(false)
        setProducts([])
    }


    return (

        <div className={styles.productTableContainer}>
            <table className={styles.productTable}>
                <thead className={styles.productTableHead}>
                    <tr>
                        <th className={styles.compare}>Compare</th>
                        <th className={styles.dataSheet}>Data sheet</th>
                        <th className={styles.partNumber}>
                            <div className={styles.headerWithFilter}>
                                <span>Part </span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        <th className={styles.manufacturer}>
                            <div className={styles.headerWithFilter}>
                                <span>Manufacturer</span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        {/* <th className={styles.matchType}>Product Number</th> */}
                        <th className={styles.stock}>
                            <div className={styles.headerWithFilter}>
                                <span>Available Stock</span>
                                <div className={styles.sortIcons}>
                                    <Uparrow />
                                    <Downarrow />
                                </div>
                            </div>
                        </th>
                        <th className={styles.unitPrice}>Unit Price</th>
                        {/* <th className={styles.requiredQuantity}>Required Quantity</th> */}

                        {allAttributeKeys?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                        {allEnvironmentalKeys?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                        {allAdditionalResources?.map((key) => (
                            <th className={styles.packageType} key={key}>{key}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {products?.map((product, index) => (
                        <tr key={index}>
                            <td className={`${styles.compare}  ${styles.tdBorder}`}>
                                <input type="checkbox"
                                    checked={selectedData?.some((p) => p._id === product._id)}
                                    onChange={(e) =>
                                        handleCheckboxChange(product, e.target.checked)
                                    }
                                />
                            </td>
                            <td className={`${styles.dataSheet}  ${styles.tdBorder}`}>
                                <div className={styles.dataCol}>
                                    <Pdf />
                                    <Leaf />
                                </div>
                            </td>
                            <td className={`${styles.partNumber}  ${styles.tdBorder}`}>
                                <div className={styles.dataRow}>
                                    <img src={product?.assets?.featuredImage[0]} style={{ width: 50, height: 50 }} />
                                    <div className={styles.dataCol}>
                                        <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${product?.productOverview?.productNumber[0]}`)} style={{ cursor: 'pointer' }}>{product?.productOverview?.productNumber[0]}</div>
                                        <div >{stripHtmlTags(product?.productOverview?.description?.[0] || product?.description)}</div>
                                    </div>
                                </div>
                            </td>
                            <td className={`${styles.manufacturer}  ${styles.tdBorder}`}>
                                <a href={product.manufacturerUrl} className={styles.manufacturer}>
                                    <div className={styles.dataColorChange}>{product?.productOverview?.manufacturer[0]?.name}</div>
                                </a>
                            </td>
                            {/* <td className={`${styles.matchType} ${styles.tdBorder}`}>
                                {product?.productOverview?.productNumber[0]}
                            </td> */}
                            <td className={`${styles.stock}  ${styles.tdBorder}`}>
                                {product?.inventory?.qtyAvailable}
                                <div className={styles.dataMargin}>in stock</div>
                                {product?.inventory?.factoryStock ?
                                    <>
                                        {product?.inventory?.factoryStock}
                                        <div className={styles.dataMargin}>factoryStock</div>
                                    </>
                                    : null}
                                <div>CanShip Immediately: {product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</div>

                            </td>
                            <td className={`${styles.unitPrice} ${styles.tdBorder}`}>
                                {product?.quantityTable
                                    ?.slice(
                                        0,
                                        expandedProducts[product?._id]
                                            ? product?.quantityTable?.length
                                            : 2
                                    )
                                    .map((i, index) => (
                                        <div key={index} className={styles.dataMargin}>
                                            {i?.breakQty}: <span style={{color:'#222222',fontWeight:700}}>₹{i?.unitPrice}</span>
                                            <div>
                                                {i?.packaging}
                                            </div>
                                        </div>
                                    ))}
                                {product?.quantityTable?.length > 2 && (
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault(); // Prevent page reload
                                            toggleShowAll(product?._id);
                                        }}
                                    >
                                        <div className={styles.dataColorChange}>
                                            {expandedProducts[product?._id]
                                                ? "Show Less"
                                                : "More Inventory"}
                                        </div>
                                    </a>
                                )}
                            </td>


                            {/* <td className={`${styles.requiredQuantity}  ${styles.tdBorder}`}>
                                <input
                                    type="text"
                                    placeholder="Enter qty"
                                    className={styles.dataInput}
                                    value={quantities[product?._id] || ""}
                                    onChange={(e) =>
                                        handleQuantityChange(product?._id, e.target.value,setQuantities)
                                    }
                                />
                                <div className={styles.dataMargin}>Min 1</div>
                                <div className={styles.dataCol} >
                                    <button
                                        className={styles.addButton}
                                        disabled={!quantities[product?._id] || quantities[product?._id] <= 0}
                                        onClick={() => addtoCart('cart', product?._id)}
                                        style={{ cursor: 'pointer', color: (!quantities[product?._id] || quantities[product?._id] <= 0) ? '#a284e6' : '#512DA8' }}
                                    >
                                        {cartLoading[product?._id] ? 'Please wait...' : '+ Add to cart'}
                                    </button>
                                    <button
                                        className={styles.scheduleButton}
                                        disabled={!quantities[product?._id] || quantities[product?._id] <= 0}
                                        onClick={() => addtoCart('schedule', product?._id)}
                                        style={{ cursor: 'pointer', color: (!quantities[product?._id] || quantities[product?._id] <= 0) ? '#a284e6' : '#512DA8' }}

                                    >
                                        {scheduleLoading[product?._id] ? 'Please wait...' : '+ Add to schedule'}
                                    </button>
                                </div>
                            </td> */}
                            {allAttributeKeys?.map((key) => (
                                <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                    {product.attributes[key]?.join(", ") || "N/A"}
                                </td>
                            ))}

                            {allEnvironmentalKeys?.map((key) => (
                                <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                    {product?.environmental[key]?.join(", ") || "N/A"}
                                </td>
                            ))}

                            {allAdditionalResources?.map((key) => (
                                <td key={key} className={`${styles.packageType}  ${styles.tdBorder}`}>
                                    {product?.additionalResources[key]?.join(", ") || "N/A"}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            {selectedData?.length > 0 ?
                <button className={styles.compareBtn} onClick={handleCompare}  >Add to compare</button>
                : null}

        </div>
    );
};

export default ProductTable;
